import { H2 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import GenericLayout from '../components/GenericLayout';
import NoPageImageSection from '../components/NoPageImageSection';

const NotFound: FC = () => (
  <GenericLayout title='Seite nicht gefunden'>
    <NoPageImageSection>
      <H2 center>404 - Seite nicht gefunden</H2>
      <Paragraph center>Diese Seite existiert nicht mehr oder wurde verschoben.</Paragraph>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(NotFound);
